<template>
  <div class="page-comp-product-price-update">
    <jw-modal :visible="visible" @ok="addEditOk" @cancel="handelCancel" class="product-update-modal" :mask-closable="false" :title="addEditTitle" title-align="start" width="920px" :body-style="{ height: '150px', padding: '0' }" unmount-on-close>
      <jw-card :bordered="false" :header-style="{ border: 'none', padding: '0px 16px' }" class="product-update-card">
        <jw-form :model="priceForm" ref="priceFormRef" @submit="handleSubmit">
          <jw-table sticky-header :data="priceForm.priceList" ref="xlUserTable" :size="large" :bordered="{ wrapper: false, headerCell: true }">
            <template #columns>
              <template v-for="(item, index) in productColumn" :key="index">
                <jw-table-column :data-index="item.dataIndex" :width="item.width" :fixed="item.dataIndex == 'operation' ? 'right' : ''">
                  <template #title>
                    <span class="hint" v-if="item.dataIndex == 'currency' || item.dataIndex == 'price' || item.dataIndex == 'periodTime'">*</span><span>{{ item.title }}</span></template
                  >
                  <template #cell="{ record, rowIndex }">
                    <!-- 产品价格-->
                    <jw-form-item v-if="item.dataIndex == 'price'" hide-label :field="`priceList.${rowIndex}.price`" :rules="{ required: true, message: $t('请输入产品价格') }" :validate-trigger="['blur', 'change']">
                      <jw-input-number :min="0" v-model="record.price" :precision="2" :placeholder="$t('请输入')"></jw-input-number>
                      <span class="tips" v-if="!record.price && record.status">{{ $t('请输入产品价格') }}</span>
                    </jw-form-item>
                    <!-- 币种-->
                    <jw-form-item v-if="item.dataIndex == 'currency'" hide-label :field="`priceList.${rowIndex}.currency`" :rules="{ required: true, message: $t('请选择币种') }" :validate-trigger="['blur', 'change']">
                      <jw-select v-model="record.currency" :options="currencyList" :placeholder="$t('请选择')" allow-search></jw-select>
                      <span class="tips" v-if="!record.price && record.status">{{ $t('请选择币种') }}</span>
                    </jw-form-item>
                    <!-- 时长单位-->
                    <jw-form-item v-if="item.dataIndex == 'timeType'" hide-label>
                      <jw-select v-model="record.timeType" :options="timeList" :placeholder="$t('请选择')" allow-search></jw-select>
                    </jw-form-item>
                    <!-- 规格单位-->
                    <jw-form-item v-if="item.dataIndex == 'unit'" hide-label>
                      <jw-select v-model="record.unit" :options="unitList" :placeholder="$t('请选择')" allow-search></jw-select>
                    </jw-form-item>
                    <!-- 有效期 -->
                    <jw-form-item v-if="item.dataIndex == 'periodTime'" hide-label :field="`priceList.${rowIndex}.periodTime`" :rules="{ required: true, message: $t('请选择有效期') }" :validate-trigger="['blur', 'change']">
                      <jw-range-picker v-model="record.periodTime" @change="onChange" />
                    </jw-form-item>
                    <!-- 操作插槽 -->
                    <jw-form-item v-if="type === 0 && item.dataIndex == 'operation'" hide-label>
                      <jw-link type="text" @click="priceForm.priceList = []">{{ $t('删除') }}</jw-link>
                    </jw-form-item>
                  </template>
                </jw-table-column>
              </template>
            </template>
          </jw-table>
        </jw-form>
      </jw-card>
    </jw-modal>
  </div>
</template>

<script>
import { reactive, toRefs, ref, inject } from 'vue';
import { Message } from '@arco-design/web-vue';
import { productService } from '@/api/';
import { tools } from '@/utils/tools.js';
import { useI18n } from 'vue-i18n';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'ProductPriceUpdate',
  setup(props, ctx) {
    const { t } = useI18n();
    console.log('1-开始创建组件-setup', props);
    const data = reactive({
      visible: false,
      addEditTitle: '',
      productId: inject('globalParams')?.id || inject('defaultParams')?.id,
      type: null,
      priceForm: {
        priceList: []
      },
      currencyList: [], //货币列表
      timeList: [], //时间单位列表
      unitList: [] //规格单位
    });
    const priceFormRef = ref();
    // 打开弹窗
    const open = (params) => {
      getEnumList();
      data.type = params.type;
      data.addEditTitle = params.title;
      if (params.type === 0) {
        params.record = {
          pId: Number(data.priceForm.priceList.length + 1),
          productId: data.productId,
          price: null,
          currency: null,
          timeType: null,
          unit: null,
          periodTime: []
        };
        // const operation = productColumn.find((v) => v.dataIndex === 'operation');
        // console.log(880, operation);
        // if (!operation) {
        //   productColumn.push({
        //     title: '操作',
        //     dataIndex: 'operation',
        //     slotName: 'operation',
        //     // fixed: 'right',
        //     width: 100
        //   });
        // }
      } else {
        // 编辑逻辑
        params.record['periodTime'] = [params?.record.startTime, params?.record.endTime];
        // params.record.price = tools.getPrice(params.record.price);
        // productColumn.forEach((item, index) => {
        //   if (item.dataIndex === 'operation') {
        //     productColumn.splice(index, 1);
        //   }
        // });
        console.log(92, productColumn);
      }
      data.priceForm.priceList = [params?.record];
      data.visible = true;
      console.log(79, data.priceForm.priceList, params);
    };
    // 取消
    const handelCancel = () => {
      data.visible = false;
    };
    // 获取产品价格下拉列表getEnumList
    const getEnumList = async () => {
      try {
        const json = await productService.getEnumList();
        const o = json.result;
        if (!json.error) {
          console.log(338, o);
          data.currencyList = o?.currencyList;
          data.timeList = o?.timeList;
          data.unitList = o?.unitList;
        } else {
          Message.error(json.error?.msg || t('获取数据失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || t('获取数据失败'));
      }
    };
    // 弹窗确认按钮
    const addEditOk = () => {
      priceFormRef.value.handleSubmit();
    };
    //
    const handleSubmit = ({ values, errors }) => {
      console.log(139, values, errors);
      if (errors) {
        data.basicInfo = false;
        const errorArray = {};
        Object.values(errors)?.forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray)?.forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        priceFormRef.value.setFields(errorArray);
        return;
      } else {
        // 提交保存
        if (data.type === 0) {
          console.log('新增接口');
          const addParams = values.priceList[0];
          const params = {
            productId: addParams.productId,
            price: tools.setPrice(addParams.price),
            currency: addParams.currency,
            timeType: addParams.timeType,
            unit: addParams.unit,
            startTime: addParams.periodTime[0],
            endTime: addParams.periodTime[1]
          };
          console.log(158, addParams, params);
          addPrice({ priceList: [params] });
        } else {
          console.log('编辑接口');
          const editParams = values.priceList[0];
          const params = {
            id: editParams.id,
            price: tools.setPrice(editParams.price),
            currency: editParams.currency,
            timeType: editParams.timeType,
            unit: editParams.unit,
            startTime: editParams.periodTime[0],
            endTime: editParams.periodTime[1]
          };
          console.log(158, editParams, params);
          editPrice({ priceList: [params] });
        }
      }
    };
    // 新增接口addPrice
    const addPrice = async (params) => {
      try {
        const json = await productService.addPrice(params);
        if (!json.error) {
          Message.success(t('操作成功'));
          // 编辑成功调一下详情列表
          data.visible = false;
          ctx.emit('cb');
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    // 编辑接口editPrice
    const editPrice = async (params) => {
      try {
        const json = await productService.editPrice(params);
        if (!json.error) {
          Message.success(t('操作成功'));
          // 编辑成功调一下详情列表
          data.visible = false;
          ctx.emit('cb');
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    //价格表头
    const productColumn = [
      {
        title: t('产品价格'),
        dataIndex: 'price',
        slotName: 'price',
        width: 130
      },
      {
        title: t('币种'),
        dataIndex: 'currency',
        slotName: 'currency',
        width: 130
      },
      {
        title: t('时长单位'),
        dataIndex: 'timeType',
        slotName: 'timeType',
        width: 130
      },
      {
        title: t('规格单位'),
        dataIndex: 'unit',
        slotName: 'unit',
        width: 130
      },
      {
        title: t('有效期'),
        dataIndex: 'periodTime',
        slotName: 'periodTime',
        width: 260
      }
      // {
      //   title: '操作',
      //   dataIndex: 'operation',
      //   slotName: 'operation',
      //   fixed: 'right',
      //   width: 100
      // }
    ];

    return {
      handelCancel,
      open,
      priceFormRef,
      productColumn,
      addEditOk,
      handleSubmit,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './index.less';
</style>
